<div class="wrapper">
  <!-- Top Right User Menu -->
  <div class="top-user-menu">
    <div class="app-navbar flex-shrink-0">
      <div class="app-navbar-item ms-1 ms-md-4" id="kt_header_user_menu_toggle">
        <div class="cursor-pointer symbol symbol-35px" data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
          data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
          <img [src]="userImage" class="rounded-3" alt="user" />
        </div>

        <div
          class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
          data-kt-menu="true">
          <div class="menu-item px-3">
            <div class="menu-content d-flex align-items-center px-3">
              <div class="symbol symbol-50px me-5">
                <img alt="Logo" [src]="userImage" />
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold d-flex align-items-center fs-5">
                  {{ EmployeeName }}
                </div>
                <a href="javascript:void(0)" class="fw-semibold text-muted text-hover-primary fs-7">
                  {{ DesignationName }}
                </a>
                <span class="fw-semibold text-muted text-hover-primary fs-7">
                  {{ storageService.getLoginDateTime() }}
                </span>
              </div>
            </div>
          </div>

          <div class="separator my-2"></div>

          <div class="menu-item px-5">
            <a [routerLink]="'/HR/Profile'" class="menu-link px-5">My Profile</a>
          </div>
          <div class="menu-item px-5">
            <a href="javascript:void(0)" class="menu-link px-5" (click)="btnSignOut()">Sign Out</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Background Elements -->
  <div class="wave-bg"></div>
  <div class="wave-trail"></div>

  <div class="infinity-container">
    <!-- Your Infinity SVG stays the same -->
    <svg class="infinity-symbol" viewBox="0 0 800 400" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:rgba(255,255,255,0.4);stop-opacity:1" />
          <stop offset="50%" style="stop-color:rgba(255,255,255,0.8);stop-opacity:1" />
          <stop offset="100%" style="stop-color:rgba(255,255,255,0.4);stop-opacity:1" />
        </linearGradient>
        <linearGradient id="glowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stop-color="rgba(255,255,255,0.3)" />
          <stop offset="50%" stop-color="rgba(255,255,255,1)" />
          <stop offset="100%" stop-color="rgba(255,255,255,0.3)" />
        </linearGradient>
      </defs>

      <path id="basePath"
        d="M 200,200 C 200,100 300,100 400,200 C 500,300 600,300 600,200 C 600,100 500,100 400,200 C 300,300 200,300 200,200"
        fill="none" stroke="rgba(255,255,255,0.25)" stroke-width="40" stroke-linecap="round" />

      <!-- Moving highlight using mask -->
      <mask id="highlightMask">
        <path id="maskPath"
          d="M 200,200 C 200,100 300,100 400,200 C 500,300 600,300 600,200 C 600,100 500,100 400,200 C 300,300 200,300 200,200"
          fill="none" stroke="white" stroke-width="40" stroke-linecap="round" stroke-dasharray="120"
          stroke-dashoffset="0">
          <animate attributeName="stroke-dashoffset" from="0" to="-1200" dur="4s" repeatCount="indefinite"
            calcMode="linear" />
        </path>
      </mask>

      <!-- Glow applied only where the mask reveals -->
      <path
        d="M 200,200 C 200,100 300,100 400,200 C 500,300 600,300 600,200 C 600,100 500,100 400,200 C 300,300 200,300 200,200"
        fill="none" stroke="url(#glowGradient)" stroke-width="40" stroke-linecap="round" mask="url(#highlightMask)"
        opacity="1" />
    </svg>

    <!-- Flowing particles -->
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
    <div class="particle"
      style="offset-path: path('M 250,225 C 250,125 350,125 450,225 C 550,325 650,325 650,225 C 650,125 550,125 450,225 C 350,325 250,325 250,225');">
    </div>
  </div>

  <!-- MAIN CONTENT AREA -->
  <div class="main-container">
    <div class="content-wrapper">

      <div class="icon-ring">
        <div *ngFor="let mod of allowedModules" class="icon" [class.disabled]="!mod.enabled"
          [ngStyle]="{top: mod.pos.top, left: mod.pos.left, transform:'translate(-50%, -50%)'}"
          (click)="mod.enabled && goTo(mod.name)">

          <img [src]="mod.icon" [alt]="mod.displayName" width="140" height="140" loading="eager" fetchpriority="high"
            decoding="async" />
          <div class="icon-label">
            {{ mod.displayName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>